import {
  Component,
  Host,
  h,
  Element,
  Prop,
  Event,
  EventEmitter,
  Method,
  State
} from "@stencil/core";

import { StzhBannerOpenEvent, StzhBannerCloseEvent } from "../../../index";

import { StzhBannerLocalizedText } from "./stzh-banner.localization"

/**
 * @slot label - Slot for label (use as alternative for property)
 * @slot link - Slot for optional stzh-link element
 */
@Component({
  tag: "stzh-banner",
  styleUrl: "stzh-banner.scss",
  scoped: true
})
export class StzhBanner {
  /** Label (slot can also be used as alternative) */
  @Prop() label: string = "";

  /** Whether to hide close button */
  @Prop() hideClose: boolean = false;

  /** Translation strings. */
  @Prop() localization: StzhBannerLocalizedText;

  /** Banner open event */
  @Event() stzhOpen: EventEmitter<StzhBannerOpenEvent>;

  /** Banner close event */
  @Event() stzhClose: EventEmitter<StzhBannerCloseEvent>;

  @Element() element: HTMLStzhBannerElement;

  /** Open state */
  @State() open: boolean = true;

  @Method()
  async show() {
    this.open = true;
    this.stzhOpen.emit({
      component: "stzh-banner"
    });
  }

  @Method()
  async hide() {
    this.open = false;
    this.stzhClose.emit({
      component: "stzh-banner"
    });
  }

  private onCloseButtonClick = () => {
    this.hide();
  }

  async componentWillLoad() {
    if (!this.localization) {
      this.localization = await window.stzhComponents.utils.fetchTranslations(this.element, "banner");
    }
  }

  render() {
    const classes = {
      "stzh-banner": true,
      "stzh-banner--has-close-hidden": this.hideClose,
      // [`stzh-banner--type-${this.type}`]: !!this.type,
    };

    return (
      <Host hidden={!this.open}>
        <div class={classes}>
          <div class="stzh-banner__container">
            <div class="stzh-banner__content">
              <div class="stzh-banner__icon-wrapper">
                <stzh-icon
                  class="stzh-banner__icon"
                  name={
                    "warning-filled"
                    // this.type === 'info' && "info-help-filled"
                    // || this.type === 'success' && "checkmark-circle-filled"
                    // || this.type === 'warning' && "important-warning-filled"
                    // || this.type === 'error' && "warning-filled"
                  }
                ></stzh-icon>
              </div>
              <div class="stzh-banner__text-wrapper">
                <div class="stzh-banner__label">
                  {this.label ? this.label : <slot name="label"></slot>}
                </div>
                <div class="stzh-banner__link">
                  <slot name="link"></slot>
                </div>
              </div>
            </div>

            {!this.hideClose &&
              <stzh-button
                class="stzh-banner__close"
                onClick={this.onCloseButtonClick}
                a11yLabel={this.localization.close}
                variant="tertiary"
                size="small"
                iconOnly={true}
                icon="close-big"
              ></stzh-button>
            }
          </div>
        </div>
      </Host>
    );
  }
}
